import ProfileLayout from "component/employeeProfile/profileLayout";
import{ memo } from "react";

const EmployeeProfilePage = () =>{
    return (
        <ProfileLayout/>
    );
}

export default memo(EmployeeProfilePage);

